module.exports = __webpack_public_path__ + "static/media/teamwork.e276d95c.jpg";